import { Component, Inject, ViewEncapsulation, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrComponent } from '../util/toastr/toastr.component';
import { Misc } from '../util/misc';
import { ComentarioService } from 'src/app/services/comentario.service';
import { UtilService } from 'src/app/services/util.service';
import { Comentario } from 'src/app/models/comentario.model';
import { MatTableDataSource } from '@angular/material/table';

@Component({
    selector: 'app-comentario-form',
    templateUrl: './comentario-form.component.html',
    styleUrls: ['./comentario-form.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ComentarioFormComponent implements OnInit {
    basicForm: UntypedFormGroup;
    loading = false;
    titulo: string = "Adicionar Comentário";
    tituloBotao: string = "Salvar";
    ehAtualizacao = false;
    dataSource = new MatTableDataSource<Comentario>();

    constructor(
        private comentarioService: ComentarioService,
        private fb: UntypedFormBuilder,
        public dialogRef: MatDialogRef<ComentarioFormComponent>,
        private toastr: ToastrComponent,
        public utilService: UtilService,
        private misc: Misc,
        @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    ngOnInit() {
        if (this.data && this.data.mensagem) {
            this.titulo = "Atualizar Comentário";
            this.tituloBotao = "Atualizar";
            this.ehAtualizacao = true;
            this.createEditForm(this.data.mensagem);
        } else {
            this.createNewForm();
        }
    }

    createNewForm() {
        this.basicForm = this.fb.group({
            mensagem: ['', Validators.required]
        });
    }

    save() {
        const comentario = new Comentario();
        comentario.id = this.data.id;
        comentario.estimativaId = this.data.estimativaId;
        comentario.mensagem = this.basicForm.value.mensagem;
        comentario.usuarioId = this.utilService.getUserId();
        comentario.ativo = true;

        if (comentario.mensagem.length > 500) {
            this.toastr.mostrarMensagem('aviso', 'Atenção', 'Comentário excede o máximo de caracteres permitido: 500');
            return;
        }

        this.loading = true;

        if (this.ehAtualizacao) {
            this.atualizarComentario(comentario);
        } else {
            this.salvarComentario(comentario);
        }
    }

    close(): void {
        this.dialogRef.close();
    }

    createEditForm(mensage: string) {
        this.basicForm = this.fb.group({
            mensagem: [mensage, Validators.required]
        });
    }

    atualizarComentario(comentario: Comentario) {
        this.comentarioService.updateByEstimativaId(comentario).subscribe({
            next: (result) => {
                this.toastr.mostrarMensagem('sucesso', 'Sucesso', 'Comentário atualizado com sucesso');
                this.dialogRef.close(result);
            },
            error: (error) => {
                this.misc.processError(error, 'Não foi possível atualizar o Comentário.');
            }
        }).add(() => {
            this.loading = false;
        });
    }

    salvarComentario(comentario: Comentario) {
        this.comentarioService.create(comentario).subscribe({
            next: (result) => {
                this.toastr.mostrarMensagem('sucesso', 'Sucesso', 'Comentário incluído com sucesso');
                this.dialogRef.close(result);
            },
            error: (error) => {
                this.misc.processError(error, 'Não foi possível inserir Comentário.');
            }
        }).add(() => {
            this.loading = false;
        });
    }
}